import { render, staticRenderFns } from "./zhibu.vue?vue&type=template&id=1a215cb3&scoped=true"
import script from "./zhibu.vue?vue&type=script&lang=js"
export * from "./zhibu.vue?vue&type=script&lang=js"
import style0 from "./zhibu.vue?vue&type=style&index=0&id=1a215cb3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a215cb3",
  null
  
)

export default component.exports